


























import Vue from 'vue'

export default Vue.extend({
  name: 'Content',
  data() {
    return {
      valueList: [
        { uid: `1`, path: `/asset/value/financial.svg`, title: `Earn more`, description: `In your company you alone control your overhead, your salary and your hourly rate. We provide full financial transparency. Always.` },
        { uid: `3`, path: `/asset/value/growth.svg`, title: `Be independent`, description: `You decide who you want to work with or what technology you want to invest in. Freedom is a wonderful thing, but always remember: with great power ... well, we are here to help.` },
        { uid: `5`, path: `/asset/value/community.svg`, title: `Belong to a community`, description: `It is dangerous to go alone - take this. Not only are we a career partner for you, we are also a career partner for a whole lot of likeminded people, all eager to support one another.` }
      ]
    }
  }
})
